import { inject, Injectable } from '@angular/core';
import { B04UserStore } from '../store/b04-user.store';

@Injectable()
export class B04UserFacade {
  private readonly store = inject(B04UserStore);

  readonly isMember = this.store.member;
}
